<template>
    <div class="main">
    <el-row>
        <el-col class="tableLeft" :span="5">
            <el-tree
                    class="tree"
                    :data="theTree"
                    :props="treeProps"
                    ref="theTree"
                    node-key="id"
                    draggable
                    highlight-current
                    :allow-drag="begin"
                    :allow-drop="allowDrop"
                    :default-expanded-keys="[2,3,4]"
                    :expand-on-click-node="false"
                    @node-click="clickTree"
            >
                <template #default="{ node, data }">
                  <span class="custom-tree-node">
                    <span>{{node.label}}</span>
                    <span class="icon">
                      <el-button v-if="data.id==0&&data.isShow" icon="el-icon-plus" type="text" size="mini"  @click.stop="add(node,data)"></el-button>
                      <el-button v-if="data.isShow&&data.id!=0" icon="el-icon-plus" type="text" size="mini"  @click.stop="appendTree(node,data)"></el-button>
                      <el-button v-if="!data.isShow&&data.id!=0" icon="el-icon-minus" type="text" size="mini" @click.stop="removeTree(node,data)"></el-button>
                    </span>
                  </span>
                </template>
            </el-tree>
            <!--<el-dialog title="请选择你要新建的图表类型" v-model="isShow" width="500px">-->
                <!--<el-radio-group v-model="tableType">-->
                    <!--<el-radio :label="1">常规图</el-radio>-->
                    <!--<el-radio :label="2">井组图</el-radio>-->
                <!--</el-radio-group>-->
            <!--</el-dialog>-->
        </el-col>
        <el-col  class="tableRight"  :span="19" style="min-width: 766px">
            <el-form  :model="theTree[0].children[thisClick.address]" label-width="100px">
                <div v-if="thisClick.id==0">
                    <el-divider content-position="left">请选择图表类型</el-divider>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="图表类型">
                                <el-radio-group v-model="tableType">
                                    <el-radio :label="1">常规图</el-radio>
                                    <el-radio :label="2">井组图</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                  <div v-if="tableType==1">
                    <el-divider content-position="left">是否支持拟合</el-divider>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="拟合选项">
                          <el-radio-group v-model="IsFitting">
                            <el-radio :label="true">支持</el-radio>
                            <el-radio :label="false">不支持</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                </div>


                <!--图表基础数据-->
                <div v-if="thisClick.id==1&&thisClick.type==1">
                    <el-divider content-position="left">基础</el-divider>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="标题文字">
                                <el-col>
                                    <el-input size="mini" @blur="rules" @input="changeName" v-model="theTree[0].children[thisClick.address].ff.title.text" placeholder="请输入标题"></el-input>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="标题颜色">
                                <el-col >
                                    <el-color-picker
                                        show-alpha :predefine="predefineColors"
                                        v-model="theTree[0].children[thisClick.address].ff.title.style.color"></el-color-picker>
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="是否显示">
                                <el-col :span="8">
                                    <el-switch v-model="theTree[0].children[thisClick.address].ff.title.style.display" active-value="block"
                                               inactive-value="none"></el-switch>
                                </el-col>
                                <span class="is" v-if="theTree[0].children[thisClick.address].ff.title.style.display=='block'">是</span>
                                <span class="is" v-else>否</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="数据来源" size="mini" >
                              <el-input
                                  placeholder="请选择"
                                  v-model="datasrcName[thisClick.address]"
                                  auto-complete="off"
                              >
                                <template #prefix>
                                  <el-icon class="el-icon-arrow-down" @click="popDataUsrTree">
                                    <edit />
                                  </el-icon>
                                </template>
                              </el-input>
                              <div
                                  v-show="isDataUsrTree"
                                  style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 102;"
                                  @click="unPopDataSurTree">
                              </div>
                              <el-tree
                                  v-show="isDataUsrTree"
                                  :highlight-current = true
                                  :default-expand-all = false
                                  :expand-on-click-node="false"
                                  :data="dataUsrTree"
                                  :props="defaultProps"
                                  node-key="DATSRC_ID"
                                  accordion
                                  @node-click="selectChangeTree"
                                  class="module-pagetree"
                                  ref="datasurTree"
                                  :filter-node-method="filterdatasurNode"
                              >
                                <template #default="scope">
                                   <span class="custom-tree-node">
                                     {{ scope.data.DATSRC_NAME }}
                                   </span>
                                </template>
                              </el-tree>
                            </el-form-item>
                        </el-col>
                      <el-col :span="4">
                        <el-button-group>
                          <el-button class="el-button--mini" type="primary" icon="el-icon-search" @click="onSearchDataUsrNode"></el-button>
                          <el-button class="el-button--mini" type="primary" icon="el-icon-close" @click="onClearDataUsrName"></el-button>
                        </el-button-group>
                      </el-col>
                    </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="数值位数">
                        <el-col :span="8">
                          <el-input-number :min="0" :max="8" v-model="theTree[0].children[thisClick.address].ff.yDecimals"/>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                    <el-divider content-position="left">X轴</el-divider>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="数据字段">
                        <el-col>
                          <el-select
                              :disabled="theTree[0].children[thisClick.address].ff.a_dataSource==''?true:false"
                              size="mini"
                              v-model="theTree[0].children[thisClick.address].ff.xAxis.a_field"
                              placeholder="请选择"
                          >
                            <el-option
                                v-for="item in formOptions[theTree[0].children[thisClick.address].ff.selectNum].TABLE_COLUMNS"
                                :key="item.COLUMN_NAME"
                                :label="item.COMMENTS"
                                :value="item.COLUMN_NAME">
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="时间类型">
                        <el-col>
                          <el-select size="mini" v-model="theTree[0].children[thisClick.address].ff.xAxis.a_type" placeholder="请选择">
                            <el-option
                                v-for="item in timeType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="showDecimalConfig">
                    <el-col :span="12">
                      <el-form-item label="时间字段">
                        <el-col>
                          <el-select
                              :disabled="theTree[0].children[thisClick.address].ff.a_dataSource==''?true:false"
                              size="mini"
                              v-model="theTree[0].children[thisClick.address].ff.xAxis.a_fieldTime"
                              placeholder="请选择"
                          >
                            <el-option
                                v-for="item in formOptions[theTree[0].children[thisClick.address].ff.selectNum].TABLE_COLUMNS"
                                :key="item.COLUMN_NAME"
                                :label="item.COMMENTS"
                                :value="item.COLUMN_NAME">
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="轴类型">
                        <el-col>
                          <el-select size="mini" v-model="theTree[0].children[thisClick.address].ff.xAxis.xAxisType" placeholder="请选择">
                            <el-option
                                v-for="item in xAxisType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                    <el-divider content-position="left">图例</el-divider>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="是否显示">
                                <el-switch
                                        v-model="theTree[0].children[thisClick.address].ff.legend.enabled"></el-switch>
                                <span class="is" v-if="theTree[0].children[thisClick.address].ff.legend.enabled==1">是</span>
                                <span class="is" v-else>否</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否浮动">
                                <el-switch v-model="theTree[0].children[thisClick.address].ff.legend.floating"></el-switch>
                                <span class="is" v-if="theTree[0].children[thisClick.address].ff.legend.floating==1">是</span>
                                <span class="is" v-else>否</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="水平位置">
                                <el-radio-group size="mini" v-model="theTree[0].children[thisClick.address].ff.legend.align">
                                    <el-radio-button  label="left">左</el-radio-button>
                                    <el-radio-button label="center">中</el-radio-button>
                                    <el-radio-button label="right">右</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="垂直位置">
                                <el-radio-group size="mini" v-model="theTree[0].children[thisClick.address].ff.legend.verticalAlign">
                                    <el-radio-button label="top">上</el-radio-button>
                                    <el-radio-button label="middle">中</el-radio-button>
                                    <el-radio-button label="bottom">下</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </div>
                <!--y轴数据-->
                <div v-if="thisClick.id=='3-1'&&thisClick.type==1">
                    <el-divider content-position="left">Y轴属性</el-divider>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="Y轴类型">
                                <el-select size="mini" v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].type" placeholder="请选择">
                                    <el-option
                                            :popper-append-to-body="false"
                                            v-for="item in YAxisType"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Y轴显隐">
                                <el-switch v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].visible"></el-switch>
                                <span class="is" v-if="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].visible==1">是</span>
                                <span class="is" v-else>否</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="标题文字">
                                <el-input  size="mini" @blur="rules" @input="changeName" v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].title.text" placeholder="请输入标题"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="标题显隐">
                                <el-switch v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].title.enabled"></el-switch>
                                <span class="is" v-if="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].title.enabled==1">是</span>
                                <span class="is" v-else>否</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="标题颜色">
                                <el-color-picker
                                    show-alpha :predefine="predefineColors"
                                    v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].title.style.color"></el-color-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-divider content-position="left" >曲线 <el-button class="addSeriesBtn" @click="addSerirs" type="text">添加</el-button></el-divider>
                    <el-row>
                        <el-col :span="24">
                            <el-table

                                    v-if="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series.length>0"
                                    :data="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series"
                                    style="width: 100%"
                                    stripe
                                    height="200"
                                    :cell-style="rowClass"
                            >
                                <el-table-column prop="name" label="名称" header-align="center">
                                    <template #default="{row, column, $index }">
                                        <el-input size="mini"  v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].name" placeholder="请输入名称"></el-input>
                                        <span v-show=false>{{column}}{{row}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="type" label="类型" header-align="center">
                                    <template #default="{row, column, $index }">
                                        <el-select
                                                size="mini"
                                                v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].type"
                                                placeholder="请选择"
                                        >
                                            <el-option
                                                    v-for="(item,index) in lineOption"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                    :selected="index==1?true:false"
                                            >
                                            </el-option>
                                        </el-select>
                                        <span v-show=false>{{column}}{{row}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="color" label="颜色" header-align="center" width="80px">
                                    <template #default="{row, column, $index }">
                                        <el-color-picker
                                            show-alpha :predefine="predefineColors"
                                            v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].color"></el-color-picker>
                                        <span v-show=false>{{column}}{{row}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isSquare" label="是否方波" header-align="center" width="80px">
                                    <template #default="{row, column, $index }">
                                        <el-switch active-value="left" inactive-value="''"
                                                   v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].step"
                                                   @change="
                                                      (currentValue, oldValue) => {
                                                        changeStepValue(
                                                            currentValue,
                                                            $index
                                                        );
                                                      }">
                                        </el-switch>
                                        <span v-show=false>{{column}}{{row}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="form" label="数据字段" header-align="center">
                                    <template #default="{row, column, $index }">
                                        <el-select  size="mini" v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].a_field" placeholder="请选择">
                                            <el-option
                                                    :popper-append-to-body="false"
                                                    v-for="item in formOptions[theTree[0].children[thisClick.address].ff.selectNum].TABLE_NUMBER"
                                                    :key="item.COLUMN_NAME"
                                                    :label="item.COMMENTS"
                                                    :value="item.COLUMN_NAME">
                                            </el-option>
                                        </el-select>
                                        <span v-show=false>{{column}}{{row}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="tableType==1" prop="form" label="汇总方式" header-align="center">
                                    <template #default="{row, column, $index }">
                                        <el-select  size="mini" @change="summary=theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].summary"
                                                    v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].summary" placeholder="请选择">
                                            <el-option
                                                    :popper-append-to-body="false"
                                                    v-for="item in SummaryType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <span v-show=false>{{column}}{{row}}</span>
                                    </template>
                                </el-table-column>
                              <el-table-column v-if="tableType==1&&summary" prop="form" label="运算字段" header-align="center">
                                <template #default="{row, column, $index }">
                                  <el-select  size="mini"
                                              v-bind:disabled="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].summary!='wei' && theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].summary!='percentage'"
                                              v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].wei_field" placeholder="请选择">
                                    <el-option
                                        :popper-append-to-body="false"
                                        v-for="item in formOptions[theTree[0].children[thisClick.address].ff.selectNum].TABLE_NUMBER"
                                        :key="item.COLUMN_NAME"
                                        :label="item.COMMENTS"
                                        :value="item.COLUMN_NAME">
                                    </el-option>
                                  </el-select>
                                  <span v-show=false>{{column}}{{row}}</span>
                                </template>
                              </el-table-column>
                                <el-table-column prop="isAdd" label="是否叠加" header-align="center" width="80px">
                                    <template #default="{row, column, $index }">
                                        <el-switch v-model="theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series[$index].stacking"></el-switch>
                                        <span v-show=false>{{column}}{{row}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" header-align="center" width="80px">
                                    <template #default="scope" header-align="center" class="tableItem">
                                        <el-button
                                                @click.prevent="deleteRow(scope.$index, theTree[0].children[thisClick.address].ff.yAxis[thisClick.yAddress].series)"
                                                type="text"
                                                size="small"
                                        >
                                            移除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </el-col>
    </el-row>
    </div>
</template>

<script>
  import { ElMessageBox,ElMessage } from 'element-plus'
  import axios from "axios"
  export default {
    name: "new-table",
    props:["massage","jsons","wells","center_wells","relation_wells","frameTime","isFitting","form_options","data_UsrTree"],
    data:function(){
      return {
        showDecimalConfig:false,//显示数值型配置
        noKeyDown:true,//禁止键盘误操作
        //noNum:0, 暂时没用
        thisClick:{},//当前点击的树
        j:1,//图表序号
        k:0,//y轴序号
        tableType:1,//新建图表类型
        isShow:false,
        isDataUsrTree: false,
        clickT:0,//点击次数
        theTree:[{
          id:0,
          isShow:true,
          label:"常规图",
          code:0,
          children:[]
        }],
        treeProps: {
          children: 'children',
          label: 'label',
        },
        tree:{},//当前图表树的信息
        form:[],//表单数据
        click:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],//每个图表树的点击次数
        TableNum:0,//总表的数量
        yNum:0,//y轴总数量
        lineOption: [
          {
            value: "line",
            label: "折线图"
          }, {
            value: "spline",
            label: "曲线图"
          }, {
            value: "area",
            label: "面积图"
          }, {
            value: "column",
            label: "柱状图"
          }, {
            value: "pie",
            label: "饼状图"
          }, {
            value: "scatter",
            label: "散点图"
          }],//点样式列表
        formOptions: [],//数据源列表
        dataUsrTree: [],//数据源列表（树形结构）
        datasrcName: [],//配置选中数据源名称列表
        timeType: [
          {
            value: '年月日',
            label: '年月日'
          }, {
            value: '年月',
            label: '年月'
          }, {
            value: '年',
            label: '年'
          }],//使用时间类型选项
        xAxisType: [
          {
            value: '时间',
            label: '时间'
          }, {
            value: '数值',
            label: '数值'
          }],//X轴类型选项
        YAxisType: [
          {
            value: 'linear',
            label: '常规'
          }, {
            value: 'logarithmic',
            label: '对数'
          }],
        SummaryType: [
          {
            value: 'sum',
            label: '求和'
          }, {
            value: 'avg',
            label: '平均'
          }, {
            value: 'wei',
            label: '加权平均'
          }, {
            value: 'percentage',
            label: '百分比'
          }],//Y轴类型选项
        summary: "",
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        predefineColors : ["#ffffff","#000000","#e7e6e6","#44546a","#5b9bd5","#ed7d31","#a5a5a5","#ffc000",
          "#4472c4","#70ad47","#7f7f7f","#0c0c0c","#171616","#222a35","#1e4e79","#833c0b","#525252",
          "#7f6000","#1f3864","#375623","#c00000","#ff0000","#ffc000","#ffff00","#92d050","#00b050",
          "#00b0f0","#0070c0","#002060","#7030a0"],//颜色板常用颜色设置
        IsFitting:this.isFitting,//是否支持拟合功能
      }
    },
    async mounted(){
      this.formOptions=this.form_options;
      this.dataUsrTree=this.data_UsrTree;
      if (this.form_options==null)
       await this.gettableSource();
      this.datasrcName=[];
      //下拉列表数据中匹配曲线配置：jsons，的数据源信息：a_dataSource
      for (let i=0;i<this.jsons.length;i++){
        let dataUsr=this.jsons[i].a_dataSource;
        for(let j=0;j<this.formOptions.length;j++){
          if (dataUsr==this.formOptions[j].TABLE_DATSID){
            this.datasrcName.push(this.formOptions[j].TABLE_COMMENTS);
          }
        }
      }
      if(this.$parent.$props.templateInfo!= undefined){
        if(this.$parent.$props.templateInfo.moduleid == '434446652B9844D18A30462D576F69DD' ||
            this.$parent.$props.templateInfo.moduleid == '818C938AF3EC4FF1BD0018843955851C') {
          this.showDecimalConfig = true;
        }
      }
      console.log("datasrcName:",this.datasrcName);
      this.getConfig()
    },
    methods:{
      //查询数据源列表信息
      async gettableSource() {
        //获取下拉列表数据
        await axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/tableSource", {
          params: {
            user_id: "01",
            app_id: "02"
          },
        }).then(res => {
          this.formOptions = res.data.data;
          this.dataUsrTree = res.data.dataTree;
          console.log("数据源列表:", res.data);
        }).catch(err => {
          console.log(err)
        })
      },
      //修改图表时将图表原信息注入
      getConfig(){
        console.log("massge",this.massage);
        if(JSON.stringify(this.massage)!="{}"){
          if(this.massage.data.length>0){
            this.massage.data.forEach((item,index)=>{
              //yAxis包含多条y轴信息:series包含所有的曲线信息,需要甄别曲线属于那条y轴 todo 为yAxis没有series的曲线配置添加series,以防止出错
              for (let i=0;i<item.yAxis.length;i++){
                if (!('series' in item.yAxis[i])){
                  let yIdex=-1;//yAxis添加series标识
                  item.yAxis[i].series=[];
                  item.series.forEach((items)=>{
                    if (items.id.toString().includes("0")){
                      yIdex++;
                    }
                    if (yIdex==i){
                      item.yAxis[i].series.push(items);
                    }
                  });
                }
              }
              this.form.push(item);

              console.log(item.a_dataSource)
              this.form[index].selectNum=null;
              for(var i=0;i<this.formOptions.length;i++){
                if(this.formOptions[i].TABLE_DATSID==item.a_dataSource){
                  this.form[index].selectNum=i;
                }
              }
              console.log("form",this.form);
              // console.log("click",this.click);
              if(this.click instanceof Array!=true){
                this.click=this.click.split(",");
                console.log(this.click)
                this.click=this.click.map(Number);
                console.log(this.click)
              }
              this.click[index]++;
              // console.log("click",this.click);
              // console.log(this.form[index]);
            });
            this.tableNum+=1;
          }
        }else{
          this.thisClick.id=0;
          this.theTree[0].label="常规图"
        }
        this.$parent.$data.isDataLoading=true;
      },
      //数据源改变时动态关联数据字段
      selectChange(data){
        console.log("data",data);
        var name = JSON.stringify(data);
        // console.log("name",name);
        name = name.substr(1);
        name = name.substring(0,name.length-1);
        // console.log(name)
        this.theTree[0].children[this.thisClick.address].ff.xAxis.a_field=null;
        //this.theTree[0].children[this.thisClick.address].ff.yAxis[this.thisClick.yAddress].series[$index]
        this.theTree[0].children[this.thisClick.address].ff.yAxis.forEach(i=>{
          i.series.forEach(item=>{
            item.a_field=null;
          })
        })
        this.formOptions.forEach((item,index)=>{
          if(item.TABLE_DATSID==name){
            this.theTree[0].children[this.thisClick.address].ff.selectNum=index;
            console.log(this.theTree[0].children[this.thisClick.address].ff.selectNum)
          }
        })
      },
      //图表树名称关联
      rules(event){
        console.log(event)
        if(event !=undefined && event.path != undefined)
        {
           if(event.path[0].value==""){
              console.log(event)
              event.path[0].focus();
              if(this.thisClick.yAddress==undefined){
                this.theTree[0].children[this.thisClick.address].ff.title.text="请输入标题"
              }else{
                this.theTree[0].children[this.thisClick.address].ff.yAxis[this.thisClick.yAddress].title.text="请输入标题"
              }
             event.path[0].value=="111"
              console.log(2222)
            }
        }
      },
      //曲线内容剧中
      rowClass(){
        return 'text-align: center;'
      },
      //是否允许拖拽
      begin(node){
        return node.data.id==1||node.data.id=="3-1"
      },
      //拖拽
      allowDrop(draggingNode, dropNode, type){
        if(draggingNode.data.id==1){
          if(draggingNode.data.id==dropNode.data.id){
            return type =='next'
          }
        }
        if(draggingNode.data.id=="3-1"){
          if(draggingNode.data.id==dropNode.data.id&&draggingNode.data.code==dropNode.data.code){
            return type =='next'
          }
        }
      },
      //方波切换动态修改数据
      changeStepValue(currentValue, index){
        console.log("方波切换", currentValue);
        this.theTree[0].children[this.thisClick.address].ff.yAxis[this.thisClick.yAddress].series[index].step = currentValue!='left'?'':currentValue;
      },
      //修改图表时触发
      changes(chartTypeString){
        this.tableType=chartTypeString == "normal" ? 1:2;
        this.click+=this.jsons.length;
        console.log("click:",this.click);
        console.log("jsons:",this.jsons);
        for(var i=0;i<this.jsons.length;i++){
          //判断 汇总方式 是否存在 加权平均 方法 todo 页面配置点击,可能在这报错，已修复
          if ('series' in this.jsons[i]){
            for (var w=0;w<this.jsons[i].series.length;w++){
              if (this.jsons[i].series[w].summary=="wei"){
                this.summary="wei";
              }
              if (this.jsons[i].series[w].summary=="percentage"){
                this.summary="percentage";
              }
            }
          }
          //存在标题名称丢失的情况，会导致报错
          let text = this.jsons[i].title.text;
          if (text == undefined || text == null)
            text = "请输入标题"
          var newTree = {
            code:i,
            id:1,
            label: text.substring(0,10),
            isShow:false,
            ff:{},
            yNum:0,
            children:[{
              code:i,
              id:3,
              label:"轴",
              isShow:true,
              children:[]
            },]

          };
          newTree.label.substring(0,8);
          newTree.ff=this.jsons[i]
          this.k = i;
          this.k+=1;
          for(var j=0;j<this.jsons[i].yAxis.length;j++){
            newTree.children[0].children.push({
              id:"3-1",
              label:this.jsons[i].yAxis[j].title.text.substring(0,7),
              index:j+1,
              code:i
            })
            this.j=j;
            this.j+=1;
            this.j++;
            newTree.yNum++;
          }
          this.theTree[0].children.push(newTree)
          console.log(newTree)
          this.clickT++;
        }
        this.k++;
      },
      //添加树
      add(d,e){
        if(this.clickT==0){
          this.isShow = true
        }
        let _this = this;
        document.addEventListener('keydown', function (event) {
          //console.log(event.code) NumpadEnter Enter
          if(event.code=='Space'||event.code=='Enter'||event.code=='NumpadEnter'){
            _this.noKeyDown=false
          }
        })
        if(this.tableType==2&&this.theTree[0].children.length>=2){
          ElMessage('由于您选择了井组图,所以只能添加两张图表')
          return
        }
        if(this.noKeyDown!=false){
          console.log(e)
          var code = this.k;
          var newChild = {
            code:this.k,
            id:1,
            label:"图表属性",
            isShow:true,
            ff:{},
            children:[
              {
                code:0,
                id:3,
                label:"轴",
                isShow:true,
                children:[],

              }
            ]
          };
          newChild.ff={
            a_dataSource:this.formOptions[0].TABLE_DATSID,//数据源id
            yDecimals:2,//数值位数
            credits:{
              enabled: false
            },
            chart: {
              borderWidth: 0,
              borderRadius: 0,
              defaultSeriesType: "spline",
              animation: true,
              marginLeft: 80,
              zoomType: "xy",
            },
            exporting: {
              enabled: false
            },
            title:{
              text:"请输入标题",
              style:{
                color:"#000",
                display:"block",
              }
            },
            subtitle: {
              text:"",
            },
            selectNum:0,
            legend:{
              enabled:true,
              align:'right',
              verticalAlign:'top',
              floating:0,
              x: 0,
              y: 0
            },
            xAxis: {
              id: "xaxis-1",
              type: "linear",
              a_type: "年月日",
              a_field: "",
              visible: true,
              title: {
                text: "请输入标题",
                enabled: false,
              },
              labels: {
                color: "#000",
                formatter: null
              },
              gridLineWidth: 0,
              tickInterval: 1,
              tickmarkPlacement: "on",
              startOnTick: true,
              endOnTick: false,
              min: 0,
              minPadding: 0,
              userCategory: [],
            },
            yAxis:[],
            series: []
          };
          newChild.isShow=false;
          newChild.code=code;
          newChild.children.forEach(item=>{
            item.children=[];
            item.code=code;
          });
          this.theTree[0].children.push(newChild);
          this.k++;
          this.clickT++;
          console.log(this.theTree[0].children)
        }
        this.noKeyDown=true

      },
      //添加轴
      appendTree(d,e){
        // //只允许添加一条y轴，y轴存在多条时，绘图会绘制多条y轴，导致绘图溢出
        // if (e.children.length>0){
        //   ElMessage.info("已添加y轴");
        //   return;
        // }
        let _this = this;
        document.addEventListener('keydown', function (event) {
          //console.log(event.code) NumpadEnter Enter
          if(event.code=='Space'||event.code=='Enter'||event.code=='NumpadEnter'){
            _this.noKeyDown=false
          }
        })
        if(this.noKeyDown!=false && e.id==3){
          console.log(this.thisClick)
          console.log(d,e)
          var code2 = this.removeByValue(this.theTree[0].children, 'code',e.code);
          console.log(code2)

          this.theTree[0].children[code2].children[0].children.push({
            id:"3-1",
            label:"Y轴",
            index:this.j,
            code:e.code,
          });
          this.j++;
          this.theTree[0].children[code2].ff.yAxis.push({
            id: "yaxis-"+(e.children.length-1),
            index:e.children.length-1,
            type: "linear",
            visible: true,
            title: {
              enabled: true,
              text: "请输入标题",
              style: {
                color: "#000"
              },
              x: 0,
              y: 0
            },
            labels: {
              color: "#000"
            },
            gridLineWidth: 0,
            tickInterval: 1,
            lineWidth: 1,
            startOnTick: true,
            endOnTick: true,
            opposite: false,
            series: []
          })
        }
        this.noKeyDown=true

      },
      //点击树
      clickTree(data){
        let obj ={};
        if(data.id==1||data.id=="3-1"||data.id==0){
          obj.type=1;//点击事件的类型,1为添加
          obj.id=data.id;//1是图表,3-1是轴
          obj.index=data.index;//第几条轴
          obj.code=data.code;//第几个张表
          obj.address=0;//当前点击事件所触发的图表在数组中的真实位置
          obj.yAddress;//当前点击事件所触发的轴在数组中的真实位置
          obj.data=[];
        }
        if(data.id==0){
          this.thisClick=obj;
        }
        if(data.id==1){
          obj.address=this.theTree[0].children.findIndex(item=>item.code==data.code);
          this.thisClick=obj;
          console.log("点击树时的click",this.thisClick)
        }
        if(data.id=="3-1"){
          let father = this.theTree[0].children.findIndex(item=>item.code==data.code);
          obj.address=father;
          obj.yAddress=this.theTree[0].children[father].children[0].children.findIndex(item=>item.index==data.index);
          this.thisClick=obj;
          console.log(obj);
          console.log("3-1click",this.thisClick)
        }
      },
      //删除树
      removeTree(node,data){
        ElMessageBox.confirm(
          '你真的要删除这一行数据吗',
          'warning', {
            confirmButtonText:"确认",
            cancelButtonText:"取消",
            type:"warning"
          }
        ).then(()=>{
          console.log(this.theTree[0])
          if(typeof(data.id)!="number"){
            const parent = node.parent
            const children = parent.data.children;
            const index = children.findIndex((d) => d.$treeNodeId === data.$treeNodeId);
            console.log(index)
            parent.parent.data.ff.yAxis.splice(index, 1)
            children.splice(index, 1)
            console.log(children)
           // var code2 = this.removeByValue(this.theTree[0].children, 'code',data.code);
            console.log(1111)
          }else{
            console.log(1111)
            var code = this.removeByValue(this.theTree[0].children, 'code',data.code);
            this.theTree[0].children.splice(code,1)
            console.log(this.theTree[0])
            this.clickT--;
          }
          this.thisClick.type=0;
          if(this.theTree[0].children.length==0){
            this.tableType=1;
            this.clickT=0;
            this.thisClick.id=0;
          }
          ElMessage({type:"success",message:"删除成功"})
        }).catch(err=>{
          console.log(err)
          ElMessage({type:"info",message:"删除已取消"})
        })

      },
      //查询数组对象的下标
      removeByValue(arr, attr, value){
        var index=0;
        for(var i in arr){
          if(arr[i][attr]==value){
            index=i;
            break;
          }
        }
        return index;
      },
      //修改标题文字后修改对应树的名称
      changeName(value){
        if(this.thisClick.id==1){
          this.theTree[0].children[this.thisClick.address].label=value.substring(0,10);
          if(value.length==0){
            this.theTree[0].children[this.thisClick.address].label="图表属性";
          }
        }
        if(this.thisClick.id=="3-1"){
          this.theTree[0].children[this.thisClick.address].children[0].children[this.thisClick.yAddress].label=value.substring(0,7);
          if(value.length==0){
            this.theTree[0].children[this.thisClick.address].children[0].children[this.thisClick.yAddress].label="Y轴";
          }
        }
      },
      //添加曲线
      addSerirs(){
        let len=this.theTree[0].children[this.thisClick.address].ff.yAxis[this.thisClick.yAddress].series.length;
        this.theTree[0].children[this.thisClick.address].ff.yAxis[this.thisClick.yAddress].series.push({
          id: "series-"+this.thisClick.yAddress+len,
          yAxis: this.thisClick.yAddress,
          dashStyle:"Solid",//曲线样式
          name: "请输入标题",//曲线名称
          lineWidth: 2,
          type: "line",//曲线类型
          color: "#000",//曲线颜色
          a_field: "",//数据字段
          summary:"sum",//汇总方式
          wei_field:"",//运算字段
          step: "",//是否方波
          stacking: false,//是否叠加
          marker: {
            enabled: true,
            symbol: "triangle-down",
            radius: 4
          },
          dataLabels: {
            enabled: true,
            color: "#000000"
          },
          showInLegend: true,
          data: [],
          pointWidth:20,//宽度 柱状图
          allowPointSelect : true,//标签显示 饼状图
        });
      },
      //曲线删除
      deleteRow(index, rows) {
        ElMessageBox.confirm(
          '你真的要删除这一行数据吗',
          'warning', {
            confirmButtonText:"确认",
            cancelButtonText:"取消",
            type:"warning"
          }
        ).then(()=>{
          rows.splice(index, 1);
          ElMessage({type:"success",message:"删除成功"})
        }).catch(()=>{
          ElMessage({type:"info",message:"删除已取消"})
        })

      },
      //返回
      goBack:function(){
        this.$forceUpdate();
      },
      //提交
      submit:function(moduleManager){
        console.log("moduleManager：",moduleManager);
        let user_id = "0000001";
        let userInfoSession = localStorage.getItem("lyqtUserInfo");
        // console.log(userInfoSession);
        if (userInfoSession == null) userInfoSession = {};
        let curUserEmplyeeId = "";
        if (userInfoSession.length > 0) {
          let jsonUserInfo = JSON.parse(userInfoSession);
          curUserEmplyeeId = jsonUserInfo.employeeId;
        }
        let _this = this;
        let form = [];
        this.theTree[0].children.forEach(item=>{
          delete item.ff.series;//清除series，因为series里的曲线数量配置不会被删除
          form.push(item.ff)
        });
        console.log("form:",form)
        for(let i =0;i<form.length;i++){
          if(form[i].xAxis.a_field==null||form[i].xAxis.a_field==""){
            ElMessage("您有未填写的X轴信息,此次提交不生效");
            return
          }
          if(form[i].yAxis.length==0){
            ElMessage("您有未添加Y轴的图表,此次提交不生效");
            return
          }
        }
        for(let i=0;i<form.length;i++){
          for(let j =0;j<form[i].yAxis.length;j++){
            if(form[i].yAxis[j].series.length==0){
              console.log(form[i])
              ElMessage("您有未添加Y轴曲线的图表,此次提交不生效");
              return
            }
            for(let k=0;k<form[i].yAxis[j].series.length;k++){
              if(form[i].yAxis[j].series[k].a_field==null||form[i].yAxis[j].series[k].a_field==""){
                ElMessage("您有未填写的曲线信息,此次提交不生效");
                return
              }
            }
          }
        }
        let chartOptionType = this.tableType=="1"?"normal":"wellgroup";
        console.log("chartOptionType",chartOptionType);
        // 从模块管理打开
        if (moduleManager != null) {
          moduleManager.template = form;
          moduleManager.chartType = chartOptionType;
          moduleManager.isFitting = this.IsFitting;
          this.$emit("sub",{code:1,chartNum:form.length});
          return;
        }
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/chartOptions",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          data:{
            user_id: user_id,
            user_empid: curUserEmplyeeId,
            chartOptionType:chartOptionType,
            chartOption:form,
            center_wells: _this.center_wells,
            wells: _this.relation_wells,
            wellSingle: _this.wells,
            time:_this.frameTime,
            chartType: this.$parent.$props.templateInfo.type,//曲线模板类型
            relations: this.$parent.$data.relations,//井组数据（指标分析）
          }
        }).then(res=>{
          if(res.status == 200) {
            if (res.data.result == "success") {
              console.log(res);
              this.$parent.$data.isFitting=this.IsFitting;
              this.$parent.$data.optionCopy=JSON.parse(JSON.stringify(res.data.data));//复制修改后的option（未进行绘制拟合曲线）
              this.$parent.getWellTitles(res.data.data);
              this.$parent.splicingWellTitle(res.data.data);
              this.$parent.drawChart(res.data.data, chartOptionType);
              _this.$forceUpdate();
            }
          }
          this.$emit("sub",{code:1,chartNum:form.length});
          _this.$forceUpdate();
        }).catch(err=>{
          console.log(err)
        });
      },

      //点击数据来源下拉按钮
      popDataUsrTree() {
        let _this = this;
        _this.isDataUsrTree = !_this.isDataUsrTree;
        console.log(this.isDataUsrTree);
        // if(_this.isDataUsrTree) {
        //   _this.$nextTick(function () {
        //     let curNode = _this.$refs.dataUsrTree.getCurrentNode();
        //     console.log(curNode);
        //     if(curNode) {
        //       _this.expandAll(true)
        //       _this.$refs.datasurTree.$el.scrollTop = 26 * (curNode.cntidx)
        //     }
        //   })
        // }
      },

      //数据来源下拉框展开时点击空白处关闭下拉框
      unPopDataSurTree() {
        this.isDataUsrTree = false;
      },

      //数据来源tree筛选方法
      filterdatasurNode(value, data) {
        // console.log("value:",value);
        // console.log("data:",data);
        if (!value) {
          return true
        }
        return data.DATSRC_NAME.indexOf(value) !== -1
      },

      //点击数据来源下拉框中数据
      selectChangeTree(data){
        console.log(data);
        this.datasrcName[this.thisClick.address]=data.DATSRC_NAME;
        this.theTree[0].children[this.thisClick.address].ff.a_dataSource=data.DATSRC_ID;
        console.log(this.datasrcName);
        this.selectChange(data.DATSRC_ID)
        this.isDataUsrTree=false;
      },

      //点击搜索按钮
      onSearchDataUsrNode() {
        console.log(this.datasrcName[this.thisClick.address])
        this.$refs.datasurTree.filter(this.datasrcName[this.thisClick.address])
        this.isDataUsrTree=true;
      },
      //点击清空按钮
      onClearDataUsrName() {
        this.datasrcName[this.thisClick.address] = ""
        this.$refs.datasurTree.filter(this.datasrcName[this.thisClick.address])
      },
    },
    watch:{
      tableType(){
        if(this.tableType==2){
          this.theTree[0].label="井组图";
        }else{
          this.theTree[0].label="常规图";
        }
        if(this.theTree[0].children.length>2&&this.tableType==2){
          ElMessage("由于您要将图表类型改为井组图,所以只能添加两张图表,请删除多余图表");
          this.tableType=1;
        }
      },
    }
  }
</script>

<style lang="less" scoped>
    :deep(input::-webkit-outer-spin-button),
    :deep(input::-webkit-inner-spin-button) {
        -webkit-appearance: none !important;
    }
    :deep(input[type='number']) {
        -moz-appearance: textfield !important;
    }
    .is{
        margin-left: 5px;
    }
    .main .el-table td,.el-table th {
        padding: 0;
    }
    .main .el-divider__text{
        color: #c6c6c6;
    }
    .el-form-item{
        margin-bottom: 0 !important;
    }
    .tableRight{
        padding-left:10px;
        border-left: #dcdfe6 1px solid;
        height:400px;
        overflow: auto;

    }
    .tableLeft{
        height:400px;
        overflow-x: scroll;
    }
    .tableLeft::-webkit-scrollbar{
        display: none;
    }
    .addSeriesBtn{
        margin-left: 10px;
    }
    .module-pagetree {
      position: absolute;
      overflow: auto;
      width: 100%;
      height: auto;
      max-height : 250px;
      border: 1px solid #ddd;
      line-height: normal;
      z-index: 204;
    }
    //:deep(.el-tree-node>.el-tree-node__children){
    //  overflow: visible !important
    //}
   //.tree-scroll{
   //  width: 200px;
   //  border: 1px solid #E7E7E7;
   //  height: 100%;
   //}
   // .flow-tree{
   //   overflow: auto;
   //   height: 300px;
   //   margin: 10px;
   //   .el-tree-node{
   //     .el-tree-node__children{
   //       overflow: visible !important
   //     }
   //   }
   // }
    .el-tree{
      width: 100%;
      overflow: auto;
    }
    .el-tree>.el-tree-node{
      display: inline-block;
      min-width: 100%;
    }
</style>
<!--<style scoped>-->

<!--</style>-->